import React from 'react'
import { Modal } from 'antd'
import Button from 'components/Button'
import { FlexWrapRole } from '../SelectCollegesDrawer/Style/style'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const CustomModal = ({
  visible,
  onClose,
  message,
  onUpdate,
  selectedCollegeCount,
  setSelectedCollegeCount,
  selectedInstituteData,
  onConfirm,
  institutesList,
  collagesRadio,
  publishedCampusList,
}) => {
  const warningMessage = () => {
    if (publishedCampusList?.length > 0 && selectedInstituteData?.length > 0) {
      return `Are you sure you want to publish this Job description to the ${selectedInstituteData?.length} selected colleges, in addition to the already published colleges?`
    } else if (publishedCampusList.length > 0) {
      return 'Are you sure you want to publish this Job description to the already published colleges?'
    } else {
      return `Are you sure you want to publish this Job description to the ${
        collagesRadio === 'Select Collages'
          ? `${selectedInstituteData?.length} selected colleges`
          : `${institutesList?.count} colleges`
      }`
    }
  }

  return (
    <Modal
      zIndex={'1001'}
      visible={visible}
      onCancel={onClose}
      centered
      footer={null}
      maskClosable={false}
      closable={false}
      bodyStyle={{
        borderRadius: '20px',
        padding: '32px 20px 32px 20px',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <span
          style={{
            fontWeight: 600,
            lineHeight: '28px',
            fontSize: '18px',
            marginBottom: '30px',
            color: '#4B465C',
          }}
        >
          <ExclamationCircleOutlined
            style={{ color: 'red', marginRight: '10px' }}
          />
          Notification
        </span>
        <div
          style={{
            fontWeight: 400,
            lineHeight: '25px',
            fontSize: '16px',
            color: '#4D566E',
            marginTop: '10px',
          }}
        >
          {warningMessage()}
        </div>
      </div>
      <br></br>

      <FlexWrapRole gap="20px" center>
        <Button.Secondary text="Back to Edit" onClick={onClose} />
        <Button.Primary text={'Confirm'} onClick={onConfirm} />
      </FlexWrapRole>
    </Modal>
  )
}

export default CustomModal
